// The on-demand home's default layout (the member layout renderer's rules are src/product/layout.js;
// no AdminLayout board draws an on-demand home, so these keys are the ones stage 5's layout screen
// offers for it): Adam's announcement, where they're up to (fixed: it moves, never hides), Up next and
// the homework of the module they're on. Pure.
const sec = (key, extra) => ({ key, shown: true, fixed: false, ...extra })

export const ON_DEMAND_HOME = [sec('news'), sec('where', { fixed: true }), sec('next'), sec('hw')]
